export default "__VITE_ASSET__CnMMSqGv__"